import React, { useEffect, useState, useContext } from "react";
// React Router
import { useParams } from "react-router-dom";
// Componentes
import ComunidadInfo from "./ComunidadInfo";
import Canonicos from "./desplegables/Canonicos";
import Civiles from "./desplegables/Civiles";
import Participaciones from "./desplegables/Participaciones";
import Vinculaciones from "./desplegables/Vinculaciones";
import Descripcion from "./desplegables/Descripcion";
import Cargos from "../cargos/Cargos";
// Custom spinner
import CustomSpinner from "../generic/CustomSpinner";
// Contexto
import { AlertBoxContext } from "../../context/alertBoxContext";
import { ModalContext } from "../../context/modalContext";
// jquery
import $ from "jquery";
// React Bootstrap
import { Container, Tabs, Tab, Alert } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
// Utils
import { objectToFormData, removeEmptyFields } from "../../utils";
import DestinosComunitarios from "./DestinosComunitarios";
//history
import { useHistory } from "react-router-dom";

const CustomTabs = styled(Tabs)`
  border-bottom: 0px;
`;

const ComunidadDetalle = ({userLevel, ...props }) => {
  //TODO
  let { id_c, id_p } = useParams();
  const idComunidad = id_c;
  const idProvincia = id_p;
  let history = useHistory();

  // Contexto
  const { modalSetShow } = useContext(ModalContext);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Datos de la misión
  const [datosComunidad, setDatosComunidad] = useState({});
  // Datos de heramanas de la comundiad
  const [datosHermanasComunidad, setDatosHermanasComunidad] = useState({});

  // Custom spinner
  const [loading, setLoading] = useState(false);

  // UEF para llamar a los datos de la comunidad
  useEffect(() => {
    handleGetDatosComunidad();
  }, []);

  //********************************************** REQUESTS ****************************************************
  
  // Obtiene los datos de la comunidad
  const getDatosComunidad = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/comunidades/${idComunidad}`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de la comunidad
  const putDatosComunidad = (data) => {
    //console.log('datos comunidad frontend: ')
    //console.log(data)
    data = objectToFormData(data);
    
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      contentType: false,
      processData: false,
      data: data,
    };
    return $.ajax(settings);
  };

  //********************************************** HANDLERS ****************************************************/
  
  // Manejador para obtener los datos de la comunidad
  const handleGetDatosComunidad = () => {
    setLoading(true);
    getDatosComunidad()
      .then((response) => {
        setLoading(false);
        removeEmptyFields(response);
        setDatosComunidad(response);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
        history.push('/provincias');
      });
  };

  // Manejador para el put de los datos de la comunidad
  const handlePutDatosComunidad = (data) => {
    setLoading(true);
    modalSetShow(false);
    putDatosComunidad(data)
      .then((response) => {
        setLoading(false);
        removeEmptyFields(response);
        setDatosComunidad(response);
        addAlert("Exito", "Se han editado los datos de la comunidad correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  //************************************************ RETURN *****************************************************/
  return (
    
    <Container className="position-relative">
      {//console.log(props.userLevel)
      }
      <CustomSpinner animation={"border"} loading={loading} />
      <ComunidadInfo datosComunidad={datosComunidad} idProvincia={idProvincia} idComunidad={idComunidad} />
      <CustomTabs unmountOnExit={true}>
        <Tab eventKey={`Datos Canónicos`} title={`Datos Canónicos`}>
          <Canonicos datosComunidad={datosComunidad} handlePutDatosComunidad={userLevel >= 9 ? handlePutDatosComunidad : null} permisoEdicion={userLevel >= 9 ? true : false} />
        </Tab>
        <Tab eventKey={`Datos Civiles`} title={`Datos Civiles`}>
          <Civiles datosComunidad={datosComunidad} handlePutDatosComunidad={userLevel >= 9 ? handlePutDatosComunidad : null} permisoEdicion={userLevel >= 9 ? true : false}  />
        </Tab>
       {userLevel >=9 && <Tab eventKey={`Datos de Misión`} title={`Datos de Misión`}>
          <Descripcion descripcion={datosComunidad?.missionDescription} handlePutDatosComunidad={handlePutDatosComunidad} />
          <Participaciones idProvincia={idProvincia} idComunidad={idComunidad} />
          <Vinculaciones idProvincia={idProvincia} idComunidad={idComunidad} />
        </Tab>}
        {userLevel >=9 &&<Tab eventKey={`Servicios Comunitarios`} title={`Servicios`}>
          <Cargos type="serviciosComunitarios" idEntidad={idProvincia} idSubEntidad={idComunidad} />
        </Tab>}
        <Tab eventKey={`Hermanas`} title={`Hermanas`}>
        {/*<Alert variant={"info"}>34nnnnnnnnn</Alert>*/}
          <DestinosComunitarios type="hermanasComunidad" idEntidad={idProvincia} idSubEntidad={idComunidad} permisoEdicion={userLevel >= 9 ? true : false}/>
          {//console.log(datosHermanasComunidad)
          }
        </Tab>
      </CustomTabs>
    </Container>
  );
};

export default ComunidadDetalle;
